<template>
  <div style="text-align:left" :class='isMobile?"cancellation-mobile":"cancellation"'>
    <h5 style="margin-bottom:30px">{{$t("v119.accountCancellation")}}</h5>
    <el-steps :active="active" finish-status="success">
      <el-step :title="$t('v119.account')"></el-step>
      <el-step :title="$t('v119.VerifyAccount')"></el-step>
      <el-step :title="$t('v119.confire')"></el-step>
      <el-step :title="$t('v119.complete')"></el-step>

    </el-steps>

    <!-- 填写账号 -->
    <el-form v-show="active == 0"  size="medium" :model="ruleForm" :rules="rules" 
    :label-position="isMobile?'top':'left'" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item v-if="loginModel=='email'" :label="$t('v119.loginAccount')" prop="email">
        <el-input  maxlength="30" v-model="ruleForm.email" width="150px" clearable  :placeholder="$t('v119.enterEmail')"></el-input>

      </el-form-item>
      <el-form-item v-if="loginModel=='phone_number'" :label="$t('v119.loginAccount')" prop="phone">
        <div style="display:flex">
          <el-select style="width:150px;margin-right:10px" v-model="ruleForm.phonePre">
            <el-option v-for="item in countryCode" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <el-input  maxlength="20"    clearable v-model="ruleForm.phone" width=""></el-input>

        </div>

      </el-form-item>
      <el-form-item  :label="$t('v119.password')" prop="password">
       
          <el-input  maxlength="30" show-password clearable  v-model="ruleForm.password" width=""></el-input>

      </el-form-item>


      <el-form-item :label="$t('v119.VerifyCode')" class="qc" style="margin-top: 10px" prop="qc">
        <el-input width="150px" :maxlength="4" v-model="ruleForm.qc" style="font-size: 12px;height: 50px;" :placeholder="$t('v119.VerifyCode')">

          <template #suffix>
            <div style="display: flex">
              <!-- <img @click="refreshQC" style="
                                width: 15px;
                                height: 15px;
                                margin-top: 15px;
                                margin-right: 5px;
                                cursor: pointer;
                                " src="../assets/sx.png" /> -->
              <vueImgVerify ref="verifyRef" />
            </div>
          </template>
        </el-input>
      </el-form-item>

      <div class="button-layout">
        <el-button v-show="loginModel =='email'"  @click="changeModel('phone_number')">{{ $t('v119.phone') }}</el-button>
        <el-button v-show="loginModel =='phone_number'"  @click="changeModel('email')">{{ $t('v119.email') }}</el-button>
        <el-button @click="verifyAccount"  type="primary">{{ $t('v119.next') }}</el-button>
      </div>

    </el-form>


     <!-- 2验证账号 -->
     <el-form v-show="active == 1"   :label-position="isMobile?'top':'left'" size="medium"   label-width="100px" class="demo-ruleForm">
      
      <el-form-item :label="$t('v119.loginAccount')" prop="account">
        <div style="display:flex">
         
          <el-input disabled  maxlength="20" v-model="loginAccountText" width=""></el-input>

        </div>

      </el-form-item>

      <el-form-item :label="$t('v119.VerifyCode')" class="qc" style="margin-top: 10px" prop="qc">
        <el-input :maxlength="6" v-model="smsCode">
                <div  slot="suffix" class="send-qc">
      

                  <div @click="dialogRecapt=true" v-if="!isSend && loginModel=='phone_number'" style="color: #2196f3">
                    {{ $t("v119.sendCode") }}
                  </div>
                  <div @click="goSend" v-else-if="!isSend " style="color: #2196f3">
                    {{ $t("v119.sendCode") }}
                  </div>
                  <div  v-else-if="isSend">{{ $t("v119.reSend") }} {{ time }}s</div>
                </div>
              </el-input>

      
      </el-form-item>

      <div class="button-layout">
        <!-- <el-button  @click="active=0">{{ $t('v119.preview') }}</el-button> -->
     
        <el-button @click="confireAccount"  type="primary">{{ $t('v119.next') }}</el-button>
      </div>

    </el-form>

    <!-- 3.确认账号信息 -->
    <div v-show="active == 2"  class="confire-layout">
        <div  v-show="!showCancellationTips">
            <div class="title">{{ $t('v119.tip1') }}</div>
                    <div class="tap-layout">
                        <div class="left">
                            <i  v-if="rishResult.pass" style="font-size:40px; color: deepskyblue;" class="el-icon-success"></i>
                            <i  v-else style="font-size:40px; color: #ffc107;" class="el-icon-warning"></i>
                        </div>
                        <div class="right" v-if="!riskloding">
                            <div >{{ $t('v119.tip2') }}</div>
                            <div class="gray">{{ $t('v119.tip3') }}</div>
                            <!-- <div class="risk-list gray" v-if="rishResult.logs" >
                                    <div v-for="item in rishResult.logs">
                                        {{ getUnixStander(item.create_time) }} - {{ item.explain }}
                                    </div>
                            </div> -->
                        </div>
                        <div class="right" style="margin-top:10px" v-else>
                            {{ $t('message.loading')}}...
                        </div>
                    </div>
                    <div class="tap-layout">
                        <div class="left">
                            <i v-if="!iotbindPass" style="font-size:40px; color:#ffc107;" class="el-icon-warning"></i>
                            <i v-else style="font-size:40px; color:deepskyblue;" class="el-icon-success"></i>
                        </div>
                        <div class="right" v-if="!iotbindLoding">
                            <div >{{ $t('v119.tip4') }}</div>
                            <div class="gray">{{ $t('v119.tip5') }}</div>
                        </div>
                        <div class="right" style="margin-top:10px" v-else>
                            {{ $t('message.loading')}}...
                        </div>
                    </div>
                    <!-- 购买记录 -->
                    <div class="tap-layout">
                        <div class="left">
                          
                          <i v-if="isBuyRecord" style="font-size:40px; color:#ffc107;" class="el-icon-warning"></i>
                            <i  v-else  style="font-size:40px; color: deepskyblue;" class="el-icon-success"></i>
                        </div>
                        <div class="right" v-if="!isBuyRecordLodding">
                            <div >{{ $t('v119.tip6') }}</div>
                            <div class="gray">{{ $t('v119.tip7') }}</div>
                        </div>
                        <div class="right" v-else>
                          {{ $t('message.loading')}}...
                        </div>
                    </div>
                    <div class="button-layout">
                        <el-button @click="thirdBtn"  type="primary">{{ $t('v119.next') }}</el-button>
                    </div>
        </div>
       

        <div v-show="showCancellationTips" class="cancellation-tips">
            <div class="title" style="font-size:18px;margin-bottom: 0px;">{{ $t('v119.accountCancellation') }}</div>
            <div v-if="config.brand=='aigosmart'" class="gray">{{ $t('v119.tip8') }}</div>
            <div v-if="config.brand=='Wisdomleads'" class="gray">{{ $t('v119.tip9') }}</div>
            <div class="item">{{ $t('v119.tip10') }}</div>
            <div class="item">{{ $t('v119.tip11') }}</div>
            <div class="item">{{ $t('v119.tip13') }}</div>
            <div  v-if="config.brand=='aigosmart'"  class="item">{{ $t('v119.tip14') }}</div>
            <div v-if="config.brand=='Wisdomleads'" class="item">{{ $t('v119.tip14w') }}</div>
            <div  v-if="config.brand=='aigosmart'"  class="item">{{ $t('v119.tip15') }}</div>
            <div v-if="config.brand=='Wisdomleads'" class="item">{{ $t('v119.tip15w') }}</div>
            <div  v-if="config.brand=='aigosmart'"  class="item">{{ $t('v119.tip16') }}</div>
            <div v-if="config.brand=='Wisdomleads'" class="item">{{ $t('v119.tip16w') }}</div>
            <el-input  style="margin-top:10px" maxlength="100" v-model="suggeseMsg" width="" :placeholder="$t('v119.tip20')"></el-input>
            
            <div class="button-layout">
                <el-button  :disabled="closeAccountDis" @click="closeAccount"  type="primary">{{ $t('v119.next') }}</el-button>
            </div>
        </div>

    </div>

     <!-- 4 完成 -->
     <div v-show="active == 3"  class="confire-layout">
        <div class="title" style="font-size:18px;margin-bottom: 40px;">{{ $t('v119.tip17') }}</div>
        <div class="button-layout" >
                <el-button @click="back"  type="primary">{{ $t('v119.back') }}</el-button>
            </div>
     </div>  


     <el-dialog :visible.sync="dialogRecapt" :title="$t('v119.tip21')"  :width="dialogWidth">
     
      <recaptcha v-if="dialogRecapt" @captchaToken="captchaToken"/>
    </el-dialog>



  </div>
</template>

<script>
import utils from "@/utils/utils.js";
import dayUtils from "@/utils/dayUtils.js";
import VueImgVerify from "@/components/VueImgVerify.vue";
import Recaptcha from "@/components/Recaptcha.vue";
import cache from "@/utils/cache";
import config from "@/utils/config";
import httpV2 from "@/utils/http_v2";
import AES from "@/utils/aesCbc.js";
export default {
  name: 'AigosmartHomeUserCancellation',
  components: {

    VueImgVerify,
    Recaptcha
    

  },
  data() {
    return {
        closeAccountDis:false,
        isBuyRecord:false,
        isBuyRecordLodding:true,
        dialogRecapt:false,
        recaptCode:"",//人机代码
        rishResult:{
            logs:[],
            pass:false,
        },//风险列表
        riskloding:true,
        iotbindLoding:true,
        iotbindPass:false,//阿里设备绑定是否通过
        suggeseMsg:"",
        isMobile:false,
        config:config,
        bgcolor: "#409eff",
        time: 0,
        isSend: false,
        showCancellationTips:false,//是否显示注销提示
        countryCode: [
        {
            value: '34',
            label: '+34',
            countryCode: "ES",
          },
          {
            value: '86',
            label: '+86'
          },
          {
            value: '1',
            label: '+1',
            countryCode: "US",
          },

          {
            value: '39',
            label: '+39',
            countryCode: "IT",
          },
          {
            value: '48',
            label: '+48',
            countryCode: "PL",
          },
          {
            value: '49',
            label: '+49',
            countryCode: "DE",
          },
          {
            value: '31',
            label: '+31',
            countryCode: "NL",
          },
          {
            value: '33',
            label: '+33',
            countryCode: "FR",
          },
          {
            value: '351',
            label: '+351',
            countryCode: "PT",
          },
        ],
   
      loginModel: "phone_number",//phone_number email
      active:0,
      smsCode:"",
      ruleForm: { phonePre: "+34", email: "", phone:"", qc: "",password:"" },
      rules: {
        email: [{ required: true, message: this.$t("v119.pleaseenter"), trigger: "blur" },
        { validator:this.validatorAccount, trigger: "blur" }],
        phone: [{ required: true, message: this.$t("v119.pleaseenter"), trigger: "blur" },
        { validator:this.validatorAccount, trigger: "blur" }],
        qc: [{ required: true, message: this.$t("v119.pleaseenter"), trigger: "blur" }],
        password: [{ required: true, message: this.$t("v119.pleaseenter"), trigger: "blur" }],

      },
      loginAccountText:"",
  
     
    };
  },

  mounted() {
    let userAgent= navigator.userAgent
    // console.info(userAgent)
    this.isMobile = utils.isMoible(userAgent);
    console.info(this.$store)

  
    if (utils.isMoible(userAgent)) {
        this.dialogWidth = "100%"
    }
    else{
      this.dialogWidth = "50%"
    }

  },

  methods: {
    captchaToken(token){
      console.info(token)
      this.dialogRecapt = false
      this.recaptCode= token
      this.goSend()
    },

    //购买记录
    buyRecord(){
      httpV2.get(
             process.env.VUE_APP_B2C_API + "/v1.0/user/order/shopping/record",
             {},
            this
            ).then((res) => {

              this.isBuyRecord = res.result
              this.isBuyRecordLodding = false
            }).catch((err) => {
              this.isBuyRecordLodding = false
            });
    },
    thirdBtn(){
        if(this.rishResult.pass && this.iotbindPass &&  !this.isBuyRecord)
        {
            this.showCancellationTips=true
        }
        else{
            this.$message.error(this.$t("v119.tip12"));
        }

    },
    //注销账号
    closeAccount(){
      this.closeAccountDis = true
      httpV2.post(
             process.env.VUE_APP_URL + "v1.0/account/closed",
            //  {
            //   account_type: "phone_number",
            //   security_code: "80975",
            //  username : "86-15005046164",
            //  },
             {
              "account_type": this.loginModel,
              "username": this.loginModel =='phone_number'?this.ruleForm.phonePre + "-" + this.ruleForm.phone:this.ruleForm.email,
              "security_code": this.smsCode,
              "reason":this.suggeseMsg
              },
            false
            ).then((res) => {

                console.info(res)
                this.active++;

            }).catch((err) => {
                console.info(err.response.data.code)
                if(err.response.data.code == 'USER_IS_NOT_EXIST')
                {
                    this.$message.error(this.$t("v119.errorMsg1"));
                }
                else if(err.response.data.code == 'USER_IS_DELETE_APPLY'){
                    this.$message.error(this.$t("v119.errorMsg2"));
                }
                else if(err.response.data.code == 'USER_IS_AT_RISK'){
                    this.$message.error(this.$t("v119.errorMsg3"));
                }
                else if(err.response.data.code == 'SECURITY_CODE_INCORRECT'){
                    this.$message.error(this.$t("v119.errorMsg4"));
                }
            });
    },



    //获取删除账号申请文章
    // account_delete_apply(){
      
    //   httpV2.get(
    //          process.env.VUE_APP_SMARTLIFE + "v1.0/articles/account_delete_apply",
    //          {},
    //         this
    //         ).then((res) => {

           
    //         }).catch((err) => {
    //             console.info(err)
    //         });

    // },
    getUnixStander(){
        return dayUtils.getUnixStander()
    },
    //获取风险数据
    getRisk(){
        httpV2.get(
             process.env.VUE_APP_URL + "v1.0/account/risk/logs",
             {},
            this
            ).then((res) => {

                this.rishResult=res
                this.riskloding=false
            });
    },
    //获取阿里设备绑定是否通过
    getIotband(){
      httpV2.get(
             process.env.VUE_APP_SMARTLIFE + "v1.0/iot/devices/check",
             {},
            this
            ).then((res) => {

                this.iotbindPass=res.pass
                this.iotbindLoding=false
            });
    },

    //确认验证码
    confireAccount(){
        if( !this.smsCode)
        {
            this.$message.error(this.$t("v119.tip18"));
            return
        }
        let params = {}
            params.tenant_id =config.TenantId
            params.send_to= this.loginModel =='phone_number'?this.ruleForm.phonePre + "-" + this.ruleForm.phone:this.ruleForm.email
            params.account_type =this.loginModel
            params.action= "Authorize"
            params.input_code = this.smsCode
            httpV2.post(
             process.env.VUE_APP_MESSAGE_URL + "v1.1/security/verify/anonymous",
             params,
            this
            ).then((res) => {
                if(res.result)
                {
                    this.getRisk()
                    this.getIotband()
                     this.buyRecord()
                    this.active++;
                }
                else{
                    this.$message.error(this.$t("v119.qcCodeError"));
                }
        
            });

    },
    back(){
        // this.$emit('close');
         //回退页面
        this.$router.go(-1)
  
    },
    //确认注销
    confieBtn(){
        this.active++;
    },
    sendCode(){
        let params = {}
            params.tenant_id =config.TenantId
            params.send_to= this.loginModel =='phone_number'?this.ruleForm.phonePre + "-" + this.ruleForm.phone:this.ruleForm.email
            params.account_type =this.loginModel
            params.action= "Authorize"
            params.language_code = cache.getStr(config.lang),
            params.captcha_token = this.recaptCode
            httpV2.post(
             process.env.VUE_APP_MESSAGE_URL + "v1.1/security/sendcode",
             params,
            this
            ).then((res) => {

        
            });

    },

    Timer() {
      if (this.time > 0) {
        this.time = this.time - 1;
        setTimeout(this.Timer, 1000);
      } else if (this.time == 0) {
        this.bgcolor = "#409eff";
        this.isSend = false;
      }
    },
    goSend() {
      if (!this.isSend) {
        this.time = 60;
        this.isSend = true;
        this.bgcolor = "gray";
        this.Timer();
        this.sendCode()
      }
    },
   
    validatorAccount(rule, value, callback){
        if(this.loginModel == 'phone_number')
        {
            if (!utils.checkNumber(this.ruleForm.phone)) {
                callback(new Error(this.$t("v119.phoneError")));         
            }
            else{
                callback();
            }

        }
        else{
            if (!utils.checkEmail(this.ruleForm.email)) {
            callback(new Error(this.$t("v119.emailError")));
         
             }
                else{
                    callback();
                }
        }
     

    },
     //登录账号
    verifyAccount(formName)  {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let postData = {};
            if(this.loginModel =='phone_number')
            {
              postData.username = this.ruleForm.phonePre + "-" + this.ruleForm.phone;
            }
            else{
              postData.username = this.ruleForm.email;
            }
           
            if(this.ruleForm.qc.toLocaleUpperCase() != this.$refs.verifyRef.imgCode)
            {
              this.$message.error(this.$t("v119.qcCodeError"));
              return;
            }

         
            let params = {}
            params.account_type =this.loginModel
            params.username= postData.username,
            params.password= AES.encrypt(this.ruleForm.password)
            params.grant_type= "password"
            params.security_code= "00000"
            params.cuid= "7ED0F7C20A1956B508BF5546007FE604"
            params.client_id=  process.env.VUE_APP_CLIENT_ID,
            params.client_secret= process.env.VUE_APP_CLIENT_SECRET
            params.source=config.source
        

            httpV2.postFrom(
             process.env.VUE_APP_URL + "v1.0/connect/token",
             params,
            this
            ).then((res) => {

                console.info(res)
                cache.setStr(config.token, "Bearer " + res.access_token);
                 this.loginAccountText=this.loginModel =='phone_number'?this.ruleForm.phonePre + "-" + this.ruleForm.phone:this.ruleForm.email
                this.active++;

            });


          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },

    //刷新验证码
    refreshQC() {
      this.$refs.verifyRef.refresh();
      console.info( this.$refs.verifyRef.imgCode);
    },
    changeModel(model)  {
        this.loginModel = model
      },

  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-input--medium .el-input__inner {
  height: 40px;
  line-height: 40px;
}

::v-deep .el-step__title{
  font-size: 13px;
}
.cancellation {
  width: 40%;
  margin: 0 auto;
  margin-top: 10%;
}
.cancellation-mobile {
  width: 90%;
  margin: 0 auto;
  margin-top: 10%;
}
.demo-ruleForm {
  margin-top: 20px;
}

.button-layout {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.confire-layout{
    .title{
        font-weight: bold;
        margin-top: 30px;
    }

    .tap-layout{
        display: flex;
        margin-top: 20px;
        .right{
            margin-left: 10px;
            .gray{
                color: #bbbbbb;
                margin-top: 10px;
                font-size: 13px;
            }
           
        }
    }

    .cancellation-tips{
        .gray{
                color: #969696;
                margin-top: 10px;
                font-size: 13px;
            }

            .item{
                margin-top: 10px;
            }
    }
}
</style>